import React, { createContext, useContext, useReducer } from 'react';
import {
  flowsReducer,
  initialFlowState,
  FlowState,
  FlowAction,
} from './workFlowReducer';

interface FlowsContextType {
  state: FlowState;
  dispatch: React.Dispatch<FlowAction>;
}

const FlowsContext = createContext<FlowsContextType | undefined>(undefined);

export const FlowsProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(flowsReducer, initialFlowState);

  return (
    <FlowsContext.Provider value={{ state, dispatch }}>
      {children}
    </FlowsContext.Provider>
  );
};

export const useFlows = (): FlowsContextType => {
  const context = useContext(FlowsContext);
  if (!context) {
    throw new Error('useFlows must be used within a FlowsProvider');
  }
  return context;
};
